import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import { observer } from 'mobx-react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  styled,
} from '@mui/material';
import LeadStore from '../../store/LeadStore';
import { SelectPipeline } from '../NewLeadDrawer/SelectPipeline';
import { toJS } from 'mobx';
import { Close } from '@mui/icons-material';
import { CustomStyledButton } from '../../utils/helper';

const CustomDialog = styled(Dialog)({
  form: {
    position: 'static',
  },
  '.MuiDialogTitle-root': {
    backgroundColor: '#cce6e6',
  },
});

export const DuplicateLeadDialog = observer(
  ({ selectedLeads, selectedPipeline, toggleDuplicateLeadsDialog, handleToggleDuplicateLeadsDialog }) => {
    const [duplicateToPipeline, setDuplicateToPipeline] = useState('');

    const handleSubmit = (e) => {
      e.preventDefault();

      LeadStore.createDuplicateLeads(selectedLeads, duplicateToPipeline.id);
    };

    const handleSelectedPipeline = (newPipeline) => {
      setDuplicateToPipeline(toJS(newPipeline));
    };

    useEffect(() => {
      LeadStore.leadDuplicateStatus && handleToggleDuplicateLeadsDialog();
    }, [LeadStore.leadDuplicateStatus]);

    const isEmpty = (value) => {
      return value === null || value === undefined || (!(typeof value === 'object') && value?.trim() === '');
    };

    return (
      <CustomDialog
        open={toggleDuplicateLeadsDialog}
        onClose={(event, reason) => reason !== 'backdropClick' && handleToggleDuplicateLeadsDialog()}
        fullWidth={true}
        maxWidth={'xs'}
        noValidate
        sx={{ position: '' }}
        PaperProps={{
          component: 'form',
          noValidate: true,
          onSubmit: (e) => handleSubmit(e),
        }}
      >
        <DialogTitle>
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Typography sx={{ fontWeight: '700', alignSelf: 'center' }} component="p">
              Duplicate Leads To
            </Typography>
            <IconButton aria-label="close" onClick={handleToggleDuplicateLeadsDialog}>
              <Close />
            </IconButton>
          </Stack>
        </DialogTitle>
        <DialogContent dividers sx={{ py: '30px !important' }}>
          <Stack direction={'column'} spacing={2}>
            <SelectPipeline
              pipelines={LeadStore.pipelines.filter((item) => item.id !== selectedPipeline?.id || selectedPipeline)}
              showError={false}
              handleSelectedPipeline={handleSelectedPipeline}
            ></SelectPipeline>
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: '25px', justifyContent: 'center' }}>
          <CustomStyledButton variant="contained" disabled={isEmpty(duplicateToPipeline)} type="submit" autoFocus>
            Duplicate Leads
          </CustomStyledButton>
        </DialogActions>
      </CustomDialog>
    );
  }
);
